<template>
  <el-dialog :close-on-click-modal="false"
    append-to-body
    custom-class="webpay"
    :visible.sync="visibleInner"
    top="1vh"
  >
    <section v-loading="loading">
      <el-card v-for="historyItem in history" :key="historyItem.date">
        <div slot="header" class="clearfix">
          <h5 class="aligner">
            <b>{{ historyItem.date }}</b>
          </h5>
          <hr />
          <el-row :gutter="20">
            <el-col :xs="24" :sm="8">
              <div class="list-item-text big">
                {{ $t('invoice_name') }}:
                <span>{{ historyItem.invoice.name }}</span>
              </div>
              <div class="list-item-text big">
                {{ $t('po_name') }}:
                <span>{{ historyItem.invoice.po_name }}</span>
              </div>
            </el-col>
            <el-col :xs="24" :sm="8">
              <div class="list-item-text big">
                {{ $t('field_total_amt') }}:
                <span
                  >{{ historyItem.invoice.total_amt }}
                  {{ historyItem.invoice.currency_id }}</span
                >
              </div>
              <div class="list-item-text big">
                {{ $t('language') }}:
                <span>{{ historyItem.invoice.language_id }}</span>
              </div>
            </el-col>
            <el-col :xs="24" :sm="8">
              <div class="list-item-text big">
                {{ $t('field_due_date') }}:
                <span>{{ historyItem.invoice.due_date }}</span>
              </div>
              <div class="list-item-text big">
                {{ $t('grace_period') }}:
                <span>{{ historyItem.invoice.grace_period }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-table class="old" :data="historyItem.invoice_item">
            <el-table-column prop="sku" :label="$t('sku')">
              <template slot-scope="scope">
                <span
                  :data-label="scope.column.label"
                  class="responsive-column"
                  >{{ scope.row.sku }}</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="product_name" :label="$t('product_name')">
              <template slot-scope="scope">
                <span
                  :data-label="scope.column.label"
                  class="responsive-column"
                  >{{ scope.row.product_name }}</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="price_base" :label="$t('price')">
              <template slot-scope="scope">
                <span
                  :data-label="scope.column.label"
                  class="responsive-column"
                  >{{ scope.row.price_base }}</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="quantity" :label="$t('quantity')">
              <template slot-scope="scope">
                <span
                  :data-label="scope.column.label"
                  class="responsive-column"
                  >{{ scope.row.quantity }}</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="total" :label="$t('total_price')">
              <template slot-scope="scope">
                <span
                  :data-label="scope.column.label"
                  class="responsive-column"
                  >{{ scope.row.quantity * scope.row.price_base }}</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </section>
    <span slot="title">
      <h4>{{ $t('invoice_history') }}</h4>
    </span>
  </el-dialog>
</template>

<script>
import apiRes from '../../core/apiRes'
export default {
  name: 'invoice-history-modal',
  props: ['visible', 'url'],
  data: () => ({
    history: [],
    loading: true
  }),
  created () {
    this.loading = true
    apiRes.get(this.url).then((data) => {
      this.loading = false
      let vars = data.page_vars
      if (vars && vars.history) {
        vars.history.forEach(historyItem => {
          historyItem.invoice = {}
          Object.keys(historyItem.records.invoice).forEach(k => {
            historyItem.invoice[k.split('.').pop()] = historyItem.records.invoice[k]
          })

          delete historyItem.records.invoice

          historyItem.invoice_item = (historyItem.records.invoice_item.length ? historyItem.records.invoice_item : [historyItem.records.invoice_item]).map(invoiceItem => {
            let item = {}
            Object.keys(invoiceItem).forEach(k => {
              item[k.split('.').pop()] = invoiceItem[k]
            })
            return item
          })
          delete historyItem.records.invoice_item

          historyItem.invoice.due_date = new Date(parseInt(historyItem.invoice.due_date) * 1000).toLocaleString(this.$localeForDate)
          // historyItem.date = new Date(parseInt(historyItem.date) * 1000).toLocaleString(this.$locale)
        })

        this.history = vars.history
      }
    })
  },
  computed: {
    visibleInner: {
      get () {
        return this.visible
      },
      set (val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    }
  }
}
</script>
